const defaultIndex = 0

const state = {
  currentResignationInterviewTabIndex: defaultIndex
}

const mutations = {
  CHANGE_CURRENTRESIGNATIONINTERVIEWTABINDEX: (state, payload) => {
    state.currentResignationInterviewTabIndex = payload
  }
}

const actions = {
  changeCurrentResignationInterviewTabIndex({ commit }, currentIndex) {
    commit('CHANGE_CURRENTRESIGNATIONINTERVIEWTABINDEX', currentIndex)
  },
  clearCurrentResignationInterviewTabIndex({ commit }) {
    const defaultIndex = 0
    commit('CHANGE_CURRENTRESIGNATIONINTERVIEWTABINDEX', defaultIndex)
  }
}

export default {
  Namespaced: true,
  state,
  mutations,
  actions
}
